import { PopoverBody, PopoverHeader, UncontrolledPopover } from 'reactstrap';

interface BottomPopOverProps {
  text: string;
  text2?: string;
  id: number;
  title: string;
  target: string;
}

const BottomPopOver = (props: BottomPopOverProps) => {
  return (
    <>
      <UncontrolledPopover
        placement="bottom"
        target={`${props.target}_${props.id}`}
        trigger={'hover'}
      >
        <PopoverHeader style={{ zIndex: '10000' }}>{props.title}</PopoverHeader>
        <PopoverBody>{props.text}</PopoverBody>
        {props.text2 && <PopoverBody>{props.text2}</PopoverBody>}
      </UncontrolledPopover>
    </>
  );
};
export default BottomPopOver;
